<template>
  <div
    ref="target"
    v-drag:target="{
      draggable: rootTable.columnDraggable,
      dragstart: dragstartHandler,
      drag: dragHandler,
      dragend: dragendHandler,
    }"
    :class="{
      'mm-thead-dragbar--disabled': !draggable,
      'mm-thead-dragbar__prev': prevColumn,
      'mm-thead-dragbar__next': nextColumn,
    }"
    class="mm-thead-dragbar"></div>
</template>
<script>
import defaultTo from "lodash/defaultTo"
import drag from "../../directives/drag"

export default {
  directives: { drag },
  props: {
    column: {
      type: Object,
    },
    nextColumn: {
      type: Object,
    },
    prevColumn: {
      type: Object,
    },
  },
  inject: {
    rootTable: {
      from: "mm-table",
      default: null,
    },
  },
  computed: {
    affectedColumn() {
      let affectedColumn = null

      if (this.nextColumn) {
        affectedColumn = this.nextColumn
      } else if (this.prevColumn) {
        affectedColumn = this.prevColumn
      }

      return affectedColumn
    },

    affectedDirection() {
      return this.nextColumn ? 1 : this.prevColumn ? -1 : 0
    },

    draggable() {
      return (
        this.rootTable.columnDraggable !== false &&
        this.column.draggable !== false &&
        (!this.affectedColumn || this.affectedColumn.draggable !== false)
      )
    },
  },
  methods: {
    dragstartHandler() {
      this.width = this.column.width

      if (this.affectedColumn) {
        this.affectedWidth = this.affectedColumn.width
      }
    },
    dragHandler({ distanceX }) {
      const affectedColumn = this.affectedColumn
      const affectedDirection = this.affectedDirection
      const MIN_DRAG_WIDTH = this.rootTable.minDragWidth

      if (!this.draggable) {
        return
      }

      const minDragWidth = defaultTo(this.column.minDragWidth, MIN_DRAG_WIDTH)
      const width = this.width + distanceX * affectedDirection
      const canDrag = width > minDragWidth

      if (!affectedColumn && canDrag) {
        this.setColumnWidth(this.column, width)
        return
      }

      const affectedMinDragWidth = defaultTo(affectedColumn.minDragWidth, MIN_DRAG_WIDTH)
      const affectedWidth = this.affectedWidth - distanceX * affectedDirection
      const affectedCanDrag = affectedWidth > affectedMinDragWidth

      if (canDrag && affectedCanDrag) {
        this.setColumnWidth(this.column, width)
        this.setColumnWidth(affectedColumn, affectedWidth)
      }
    },
    dragendHandler() {
      const data = {
        column: this.column,
        width: this.column.width,
        oldWidth: this.width,
      }
      if (this.affectedColumn) {
        Object.assign(data, {
          affectedColumn: this.affectedColumn,
          affectedColumnWidth: this.affectedColumn.width,
          affectedColumnOldWidth: this.affectedWidth,
          affectedDirection: this.affectedDirection,
        })
      }
      this.rootTable.$emit("column-width-dragend", data, this.rootTable.store.state.columns)
    },

    setColumnWidth(column, width) {
      column.width = width
      column.flex = false
    },
  },
}
</script>
